export default class Locale_ReportFilterEditor { 
	Property: string = "Property ie. Project/ProjectId";
	Operator: string = "Operator";
	SelectContextProperty: string = "Select context property";	
}